import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";
import { fetchNumberOfNewRentalHouse, NewRentalHousePoint } from "src/site/estat";
import { ChartSpec, debounce, isSp, renderChart } from "src/site/recharts";

// Site::PrefectureArea::NumberOfNewRentalHouse::Component の Stimulus コントローラ。
// landIeul: components/domainParts/NumberOfNewRentalHouse/index.tsx。

class SitePrefectureAreaNumberOfNewRentalHouseController extends Controller<HTMLElement> {
  static targets = ["graph", "descriptionIncrease", "descriptionDecrease"];
  static values = { areaCode: String };

  declare readonly graphTarget: HTMLElement;
  declare readonly descriptionIncreaseTarget: HTMLElement;
  declare readonly descriptionDecreaseTarget: HTMLElement;
  declare readonly areaCodeValue: string;

  private graphData: NewRentalHousePoint[] = [];
  private onResize?: () => void;

  connect(): void {
    this.onResize = debounce(() => this.draw());
    window.addEventListener("resize", this.onResize);
    void this.load();
  }

  disconnect(): void {
    if (this.onResize) window.removeEventListener("resize", this.onResize);
  }

  private async load(): Promise<void> {
    const result = await fetchNumberOfNewRentalHouse(this.areaCodeValue);
    if (!result) return;
    this.graphData = result.graphData;
    this.descriptionIncreaseTarget.hidden = !result.isIncrease;
    this.descriptionDecreaseTarget.hidden = result.isIncrease;
    this.draw();
  }

  private draw(): void {
    if (this.graphData.length === 0) return;
    renderChart(this.graphTarget, this.spec());
  }

  private spec(): ChartSpec {
    const sp = isSp();
    const tickFontSize = sp ? "10px" : "12px";
    return {
      kind: "line",
      data: this.graphData as unknown as ChartSpec["data"],
      xKey: "year",
      xPadding: { left: 20, right: 20 },
      xTickFontSize: tickFontSize,
      yTickFontSize: tickFontSize,
      yUnit: "戸",
      yLocaleString: true,
      curve: "monotone",
      legendWrapperStyle: {
        "font-size": sp ? "10px" : "15px",
        "margin-left": "20px",
        "line-height": "40px",
      },
      series: [
        {
          key: "rentalHouse",
          name: "新規貸家着工数",
          stroke: "#FF367F",
          fill: "#FF367F",
          strokeWidth: sp ? 2 : 3,
          unit: "戸",
        },
      ],
      containerStyle: "width:100%;height:100%;min-width:0",
    };
  }
}

application.register(
  "site--prefecture-area--number-of-new-rental-house",
  SitePrefectureAreaNumberOfNewRentalHouseController,
);
